import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';
import { Collapse } from 'src/ui/components/collapse/sports/04/Collapse';
import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { EachWayDetails } from 'src/domains/sportsbook/webview/components/marketHeader/EachWayDetails';

interface MarketHeaderPropsType {
    name: string;
    isOpen: boolean;
    onClick: () => void;
    marketId: MarketId;
}

export const MarketHeader = observer('MarketHeader', (props: MarketHeaderPropsType): JSX.Element | null => {
    const { isOpen, marketId, name, onClick } = props;
    const common = useCommon();
    const languagesState = LanguagesState.get(common);

    const marketModel = marketId.getModel();
    if (marketModel === null) {
        return null;
    }

    const nameToDisplay =
        name === 'First Goalscorer'
            ? languagesState.getTranslation('_market.player to score', 'Player To Score')
            : languagesState.getMarketTranslationName(marketModel);

    const eachWay = marketModel.eachWay;
    const terms = eachWay?.terms[0];
    const shouldShowEachWay = eachWay !== undefined && eachWay.offered === true && terms !== undefined;

    return (
        <Collapse
            dataTest='collapse-market'
            dataTestMarketName={nameToDisplay}
            handleToggle={onClick}
            isOpen={isOpen}
            title={nameToDisplay}
        >
            {shouldShowEachWay ? <EachWayDetails terms={terms} /> : null}
        </Collapse>
    );
});
